/* ======== Globals ========= */
import { create } from "zustand";

/* ======== Types ========= */
import type { Apps } from "@memorang/constants/apps";
import type { CustomConfigType } from "@memorang/constants/config/schema";
import { customConstants } from "../configs/custom-app-config";
import { buildType } from "../helpers/app-identity";

/* ======== Store Creation ========= */
interface AppState extends CustomConfigType {
	setAppConfig: (config: CustomConfigType) => void;
}

const appConfig = customConstants[buildType as Apps];

export const useAppStore = create<AppState>((set) => ({
	...appConfig,
	setAppConfig: (config) => set((state) => ({ ...state, ...config })),
}));
